// redux/store.js
import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import authReducer from "./reducers/authReducer";
import LeaveTypeReducer from "./reducers/Leave/LeaveTypeReducer";
import LeaveAdjustmentReducer from "./reducers/Leave/LeaveAdjustmentReducer";
import LeaveRequestReducer from "./reducers/Leave/LeaveRequestReducer";
import LeaveAllocationReducer from "./reducers/Leave/LeaveAllocationReducer";
import HolidayReducer from "./reducers/Leave/HolidayReducer";
import LeaveConfigReducer from "./reducers/Leave/LeaveConfigReducer";
import jobReducer from "./reducers/jobReducer";
import todayAttendanceReducer from "./reducers/TodayReducer";
import {
  timeSlotReducer,
  otAssignReducer,
  otjobAttendanceReducer,
  otdetailsReducer,
} from "./reducers/OTReducer.js";
import {
  assignjobReducer,
  assignLocationReducer,
  jobAssignmentReducer,
} from "./reducers/AssignReducer.js";
import { attendanceReducer } from "./reducers/JobHistoryAllReducer.js";
import { INOUTReducer } from "./reducers/QrReducer.js";
import { OTDetailsReducer } from "./reducers/OTdetailsReducer";
import { sundayDataReducer, holidaysReducer } from "./reducers/OTReducer.js";
import SupervisorWiseOTReducer from "./reducers/SupervisiorWiseReducer.js";
import NonAllocatedEmpReducer from "./reducers/NonAllocatedEmpReducer.js";
import LocationBasedReducer from "./reducers/LocationBasedReducer.js";
import LocationBasedDutyTypeReducer from "./reducers/LocationBasedDutyTypeReducer.js";
import EmpAllocationReducer from "./reducers/EmpAllocationReducer.js";
import LocationNotOffReducer from "./reducers/LocationNotOffReducer.js";
import OTNonAllocatedLocReducer from "./reducers/OTNonAllocatedLocReducer.js";
import EmpDiscripencyReducer from "./reducers/EmpDiscripencyReducer.js";
import EWODiscripencyReducer from "./reducers/EWODiscripencyReducer.js";
import EmpAllocationCDLJobsReducer from "./reducers/EmpAllocationCDLJobsReducer.js";
import ShiftReducer from "./reducers/ShiftReducer.js";
import rosterReducer from "./reducers/RosterReducer";
import RosterAttendanceReducer from "./reducers/RosterAttendanceReducer.js";
import AbsentLast5Reducer from "./reducers/AbsentLast5Reducer";
import bannerReducer from "./reducers/BannerReducer.js"; // Add this import
import AttendanceDetailsReducer from "./reducers/AttendanceDetailsReducer.js";
import AttendanceMonthlyReducer from "./reducers/AttendanceMonthlyReducer.js";
import {
  PostEmployeeDetailsReducer,
  PostEmployeeQualificationsReducer,
  PostEmployeeDependentsReducer,
  PostPreviousEmploymentReducer,
  PostWorkplaceRelationshipsReducer,
  GetAllEmployeesReducer,
  GetEmployeeByServiceNoReducer,
  GetEmployeeDependentsReducer,
  GetEmployeeQualificationsReducer,
  GetPreviousEmploymentReducer,
  GetWorkplaceRelationshipsReducer,
} from "./reducers/EmployeeRegisterReducer.js";
import {
  PostPaymentReducer,
  PostWelfareBenefitsReducer,
  PostImportantInformationReducer,
  GetPaymentReducer,
  GetWelfareBenefitsReducer,
  GetImportantInformationReducer,
} from "./reducers/EmployeeFinancialReducer.js";
import {
  getAllEmployees,
  getEmployeeByServiceNo,
  getEmployeeDependents,
  getEmployeeQualifications,
  getPreviousEmployment,
  getWorkplaceRelationships,
  postEmployeeDependents,
  postEmployeeDetails,
  postEmployeeQualifications,
  postPreviousEmployment,
  postWorkplaceRelationships,
} from "./actions/EmployeeRegisterAction.js";
// Combine all reducers into one root reducer
const rootReducer = combineReducers({
  auth: authReducer,
  job: jobReducer,
  todayAttendance: todayAttendanceReducer,
  otjobAttendance: otjobAttendanceReducer,
  otdetails: otdetailsReducer,
  assignJob: assignjobReducer,
  assignLocation: assignLocationReducer,
  assignJobpost: jobAssignmentReducer,
  timeSlots: timeSlotReducer,
  assignOTpost: otAssignReducer,
  attendance: attendanceReducer,
  otdetails: OTDetailsReducer,
  sundayData: sundayDataReducer,
  holidays: holidaysReducer,
  qr: INOUTReducer,
  supervisorWiseOT: SupervisorWiseOTReducer,
  nonAllocatedEmp: NonAllocatedEmpReducer,
  locationBased: LocationBasedReducer,
  locationBasedDutyType: LocationBasedDutyTypeReducer,
  empAllocation: EmpAllocationReducer,
  locationNotOff: LocationNotOffReducer,
  otNonAllocatedLoc: OTNonAllocatedLocReducer,
  empDiscripency: EmpDiscripencyReducer,
  EWODiscripency: EWODiscripencyReducer,
  empAllocationCDLJobs: EmpAllocationCDLJobsReducer,
  shifts: ShiftReducer,
  roster: rosterReducer,
  rosterAttendance: RosterAttendanceReducer,
  absentLast5: AbsentLast5Reducer,
  banner: bannerReducer, // Add the banner reducer
  attendanceDetails: AttendanceDetailsReducer,
  attendanceMonthly : AttendanceMonthlyReducer,
  postEmployeeDetails: PostEmployeeDetailsReducer,
  postEmployeeDependents: PostEmployeeDependentsReducer,
  postEmployeeQualifications: PostEmployeeQualificationsReducer,
  postPreviousEmployment: PostPreviousEmploymentReducer,
  postWorkplaceRelationships: PostWorkplaceRelationshipsReducer,
  getAllEmployees: GetAllEmployeesReducer,
  getEmployeeByServiceNo: GetEmployeeByServiceNoReducer,
  getWorkplaceRelationships: GetWorkplaceRelationshipsReducer,
  getPreviousEmployment: GetPreviousEmploymentReducer,
  getEmployeeDependents: GetEmployeeDependentsReducer,
  getEmployeeQualifications: GetEmployeeQualificationsReducer,
  postPayment: PostPaymentReducer,
  postWelfareBenefits: PostWelfareBenefitsReducer,
  postImportantInformation: PostImportantInformationReducer,
  getPayment: GetPaymentReducer,
  getWelfareBenefits: GetWelfareBenefitsReducer,
  getImportantInformation: GetImportantInformationReducer,
  leaveTypes: LeaveTypeReducer,
  leaveAdjustments: LeaveAdjustmentReducer,
  leaveRequests: LeaveRequestReducer,
  leaveAllocations: LeaveAllocationReducer,
  leaveHolidays: HolidayReducer,
  leavePolicies: LeaveConfigReducer,
});

// Create the Redux store with rootReducer and middleware
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;

// // // redux/store.js
// // import { configureStore } from "@reduxjs/toolkit";
// // import authReducer from "./reducers/authReducer.js";
// // import jobReducer from "./reducers/jobReducer";
// // import todayAttendanceReducer from "./reducers/TodayReducer"
// // import {assignjobReducer,assignLocationReducer,jobAssignmentReducer} from "./reducers/AssignReducer.js";
// // import { assignJob } from "./actions/AssignAction.js";

// // export const store = configureStore({
// //   reducer: {
// //     auth: authReducer,
// //     job: jobReducer,
// //     todayAttendance: todayAttendanceReducer,
// //     assignJob:assignjobReducer,
// //     assignLocation:assignLocationReducer,
// //     assignJobpost:jobAssignmentReducer,
// //   },
// // });

// import { createStore, applyMiddleware, combineReducers } from "redux";
// import {thunk} from "redux-thunk";
// import authReducer from "./reducers/authReducer";
// import jobReducer from "./reducers/jobReducer";
// import todayAttendanceReducer from "./reducers/TodayReducer";
// import {timeSlotReducer, otAssignReducer, otjobAttendanceReducer, otdetailsReducer} from "./reducers/OTReducer.js"
// import {
//   assignjobReducer,
//   assignLocationReducer,
//   jobAssignmentReducer,
// } from "./reducers/AssignReducer.js";
// import { attendanceReducer } from "./reducers/JobHistoryAllReducer.js";
// import { INOUTReducer } from "./reducers/QrReducer.js";
// import { OTDetailsReducer } from "./reducers/OTdetailsReducer";
// import { sundayDataReducer, holidaysReducer } from "./reducers/OTReducer.js"
// import SupervisorWiseOTReducer from "./reducers/SupervisiorWiseReducer.js";
// // import JobWiseOTReducer from "./reducers/JobWiseReducer.js";
// import NonAllocatedEmpReducer from "./reducers/NonAllocatedEmpReducer.js";
// import LocationBasedReducer from "./reducers/LocationBasedReducer.js";
// import EmpAllocationReducer from "./reducers/EmpAllocationReducer.js";
// import LocationNotOffReducer from "./reducers/LocationNotOffReducer.js";
// import OTNonAllocatedLocReducer from "./reducers/OTNonAllocatedLocReducer.js";
// import EmpDiscripencyReducer from "./reducers/EmpDiscripencyReducer.js";
// import EWODiscripencyReducer from "./reducers/EWODiscripencyReducer.js";
// import EmpAllocationCDLJobsReducer from "./reducers/EmpAllocationCDLJobsReducer.js";
// import ShiftReducer from "./reducers/ShiftReducer.js";
// import rosterReducer from "./reducers/RosterReducer";
// import RosterAttendanceReducer from "./reducers/RosterAttendanceReducer.js";
// import AbsentLast5Reducer from "./reducers/AbsentLast5Reducer";

// // Combine all reducers into one root reducer
// const rootReducer = combineReducers({
//   auth: authReducer,
//   job: jobReducer,
//   todayAttendance: todayAttendanceReducer,
//   otjobAttendance: otjobAttendanceReducer,
//   otdetails:otdetailsReducer,
//   assignJob: assignjobReducer,
//   assignLocation: assignLocationReducer,
//   assignJobpost: jobAssignmentReducer,
//   timeSlots: timeSlotReducer,
//   assignOTpost:otAssignReducer,
//   attendance: attendanceReducer,
//   otdetails: OTDetailsReducer, //ot1details:otdReducer,
//   sundayData: sundayDataReducer,
//   holidays:holidaysReducer,
//   qr:INOUTReducer,
//   supervisorWiseOT: SupervisorWiseOTReducer,
//   // jobWiseOT: JobWiseOTReducer,
//   nonAllocatedEmp: NonAllocatedEmpReducer,
//   locationBased: LocationBasedReducer,
//   empAllocation: EmpAllocationReducer,
//   locationNotOff: LocationNotOffReducer,
//   otNonAllocatedLoc: OTNonAllocatedLocReducer,
//   empDiscripency: EmpDiscripencyReducer,
//   EWODiscripency: EWODiscripencyReducer,
//   empAllocationCDLJobs: EmpAllocationCDLJobsReducer,
//   shifts: ShiftReducer,
//   roster: rosterReducer,
//   rosterAttendance: RosterAttendanceReducer,
//   absentLast5: AbsentLast5Reducer,
// });

// // Create the Redux store with rootReducer and middleware
// const store = createStore(rootReducer, applyMiddleware(thunk));

// export default store; // Ensure this is the default export